import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { PlanConsumer, PlanProvider } from '../../../../../PlanContext'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeletePlan = ({
                          index, data, setData, count, setCount, handleNotificationCall,
                          handleDeletePlanDialog, viewDeletePlanDialog, openDeletePlanDialog
                        }) => {
  const classes = useStyles()

  return (
    <PlanProvider pageAction={'delete'} handleNotificationCall={handleNotificationCall}>
      <PlanConsumer>
        {({ deletePlanLoading, handleDeletePlan }) => (
          <>
            {!!viewDeletePlanDialog &&
            <Dialog
              keepMounted
              fullWidth
              maxWidth={'sm'}
              open={openDeletePlanDialog}
              classes={{ paper: classes.NewOrderDialogPaper }}
              TransitionComponent={Transition}
              onClose={handleDeletePlanDialog}
              aria-labelledby="BasicInfoDialog"
              aria-describedby="BasicInfoDialog"
            >
              <IconButton
                edge={false}
                className={classes.NewOrderDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleDeletePlanDialog}
              >
                <CloseIcon/>
              </IconButton>
              <DialogContent className={classes.NewOrderDialogContent}>
                {!!deletePlanLoading && <FormLoader loading={true}/>}
                <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Plan.DeleteMessage' values={{ title: data[index].title }}/></p>
                </Box>
              </DialogContent>
              <DialogActions className={classes.NewOrderDialogFooter}>
                <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                        onClick={() => {
                          handleDeletePlan(index, data, setData, count, setCount, handleDeletePlanDialog)
                        }}>
                  <FormattedMessage id='Page.Action.Delete'/>
                </Button>
                <Button onClick={handleDeletePlanDialog} color="primary">
                  <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
                </Button>
              </DialogActions>
            </Dialog>
            }
          </>
        )}
      </PlanConsumer>
    </PlanProvider>
  )
}

export default DeletePlan
